import { defineAsyncComponent } from 'vue';
import { useSpaConfig } from '@/composables/useSpaConfig';
import { useSectionsStore } from '@/stores/sections';

export function getOneTeaserAssets(version = import.meta.env.ONE_TEASER_VERSION) {
  return {
    css: `https://assets.oneweb.mercedes-benz.com/plugin/sccs-one-teaser/${version}/style.css`,
    js: `https://assets.oneweb.mercedes-benz.com/plugin/sccs-one-teaser/${version}/App.js`,
  };
}

/**
 * OneTeaser component.
 * Will add the necessary styles to the document head.
 */
export function useOneTeaser(): OneTeaserComponent {
  const oneTeaserVersion = useSpaConfig().offerTeaser?.oneTeaserVersion || import.meta.env.ONE_TEASER_VERSION;
  const { css, js } = getOneTeaserAssets(oneTeaserVersion);

  return defineAsyncComponent<OneTeaserComponent>(async () => {
    if (!import.meta.env.SSR) {
      document.head.appendChild(Object.assign(document.createElement('link'), { rel: 'stylesheet', href: css }));
    }
    try {
      return await import(/* @vite-ignore */ js);
    } catch (error) {
      useSectionsStore().handleError(
        ['offerTeaser'],
        error,
        `Failed to load OneTeaser component version: ${oneTeaserVersion}`,
      );

      return () => null;
    }
  });
}

export type OneTeaserComponent = typeof import('@sccs/one-teaser').default;
